import { Row, Col, Pagination, Spinner } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useEffect, useState } from "react";
import { right } from "../../assets/img";

export function Table2({
  columns,
  data,
  tableHeight,
  setPageno,
  pagecount,
  show,
  loading = false,
  pageno,
  color = "#000",
  removePagination,
}) {
  const navigate = useNavigate();
  const [pagenumber, setPagenumber] = useState(1);
  const dataLength = (data ?? [])?.length;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    pageCount,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: pageno ? pageno - 1 : 0,
        pageSize: removePagination ? dataLength : 20,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setPagenumber(pageIndex + 1);
  }, [pageIndex]);

  return (
    <div className="table-design">
      <BTable
        size="sm"
        responsive
        bordered
        {...getTableProps()}
        className="custom-table mb-0"
      >
        <style>
          {`
                        .table-responsive {
                            height: ${tableHeight ? tableHeight : "null"};
                            overflow-y: auto;
                            overflow-x: auto;
                        }

                        .custom-table {
                                  border: 1px solid #bcbcbc !important;
                            border-collapse: collapse !important;
                            width: 100%;
                            background-color: #fff !important;
                        }

                        .custom-table th,
                        .custom-table td {
                                   border: 1px solid #bcbcbc !important;
                            text-align: center;
                            vertical-align: middle;
                            padding: 0px 0px !important; /* compact row height */
                            line-height: 1.3 !important;
                        }

                        /* ✅ Header background color */
                        .custom-table thead th {
                            background-color: #F0EDE6 !important;
                            position: sticky;
                            top: 0;
                        }

                        /* ✅ Alternating (zebra) row colors */
                        .custom-table tbody tr:nth-child(odd) {
                            background-color: #ffffff !important;
                        }
                        .custom-table tbody tr:nth-child(even) {
                            background-color: #F0EDE6 !important;
                        }

                        /* ✅ Optional hover highlight */
                        .custom-table tbody tr:hover {
                            background-color: #e6e2d8 !important;
                        }
                    `}
        </style>

        <thead>
          {headerGroups.map((headerGroup, ind) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={ind}>
              {headerGroup.headers.map((column, indx) => (
                <th
                  className="px-2 text-center"
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  <h4 className="f3 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 py-1 primary">
                    {column.Header === "Commission Amount" ? (
                      <>
                        Commission
                        <br />
                        Amount
                      </>
                    ) : column.Header === "Betting Amount" ? (
                      <>
                        Betting
                        <br />
                        Amount
                      </>
                    ) : (
                      column.render("Header")
                    )}
                  </h4>
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {loading ? (
            <tr style={{ backgroundColor: "#f0ede6" }}>
              <td
                style={{ backgroundColor: "#f0ede6" }}
                colSpan={columns.length}
                className="text-center py-5"
              >
                <Spinner animation="border" size="sm" /> &nbsp; Loading data...
              </td>
            </tr>
          ) : page.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-3"
                style={{
                  color: "#666",
                  fontWeight: "600",
                  backgroundColor: "#F0EDE6",
                  fontSize: "14px",
                }}
              >
                No data
              </td>
            </tr>
          ) : (
            page.map((row, i) => {
              prepareRow(row);
              return (
                <tr className="f3" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, ind) => {
                    const columnKey = cell.column.id;
                    const rowData = row.original;
                    let cellValue = cell.value;

                    if (columnKey === "lot_details" && cellValue != null) {
                      const timeValue = rowData.time || "";
                      cellValue = (
                        <div
                          className="tbel-s"
                          style={{
                            whiteSpace: "pre-line",
                            textTransform: "uppercase",
                            lineHeight: "1.2",
                            width: "150px",
                            minWidth: "150px",
                            wordWrap: "break-word",
                          }}
                        >
                          {cell.value}
                          {timeValue && (
                            <div className="tbel-s">{timeValue}</div>
                          )}
                        </div>
                      );
                    } else {
                      cellValue = cell.render("Cell");
                    }

                    return (
                      <td
                        {...cell.getCellProps()}
                        key={ind}
                        style={{
                          color: color,
                          textAlign: [
                            "Date",
                            "Delete",
                            "Action",
                            "Commission Amount",
                            "Betting Amount",
                          ].includes(cell.column.Header)
                            ? "center"
                            : "center",
                          verticalAlign: "middle",
                          backgroundColor: i % 2 === 0 ? "#ffffff" : "#F0EDE6", // ✅ add this
                        }}
                        className="fs-xs-14 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 px-2 py-1 gray2 list-data"
                      >
                        {cellValue}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </BTable>

      {show && !pagecount && (
        <Row className="justify-content-between table-show p-2 w-100 bg-primary2">
          <Col className="d-flex ac-jb">
            <p className="px-1 mb-0 f3">Total Pages {pageCount}</p>
            <Pagination className="gap-1 pointer mb-0 d-flex ac-js">
              {pagenumber > 1 && (
                <PlayArrowIcon
                  className="left-arrow"
                  onClick={() =>
                    setPagenumber((prev) => (prev > 1 ? prev - 1 : 1))
                  }
                />
              )}

              <input
                type="number"
                style={{ width: "40px", height: "30px" }}
                className="form-control1 ml-2 p-1 py-1 text-center"
                value={pagenumber}
                onChange={(e) => {
                  if (!Number(e.target.value)) {
                    setPagenumber(e.target.value);
                    return;
                  }
                  if (e.target.value > pageCount) {
                    gotoPage(pageCount - 1);
                    setPagenumber(pageCount);
                    return;
                  }
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                  setPagenumber(e.target.value);
                }}
              />

              <img src={right} width={30} height={30} alt="" />
              <PlayArrowIcon
                className="right-arrow"
                onClick={() =>
                  setPagenumber((prev) => (prev < pageCount ? prev + 1 : prev))
                }
              />
            </Pagination>
          </Col>
        </Row>
      )}
    </div>
  );
}
